import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import VerticalTab from "../Tab/VerticalTab";
import { allRoles } from "../../constants/caseManagementData";
import {
  Step,
  StepConnector,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
  stepConnectorClasses,
} from "@mui/material";
import styled from "styled-components";
import { useSelector } from "react-redux";

const CommentsBox = ({ data = [], sidebarTable = false, employee_name }) => {
  const { lobName } = useSelector((state) => state?.CaseDescriptionSlice);
  const [tabValue, setTabValue] = useState("");
  const [renderData, setRenderData] = useState(null);
  const CustomStepIcon = () => (
    <Box
      sx={{
        width: "9.8px",
        height: "9.8px",
        ml: "8px",
        borderRadius: "50%",
        backgroundColor: "#e52126",
      }}
    />
  );
  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`& .${stepConnectorClasses.line}`]: {
      minHeight: "1rem", // Minimum height for the line
    },
  }));
  const handleChange = (e, index) => {
    setTabValue(e.target.innerText);
  };
  const tabs =
    data &&
    data.map((item) => ({
      label: item?.role_label,
    }));
  useEffect(() => {
    setTabValue(tabs[0]?.label);
  }, [data]);
  useEffect(() => {
    if (tabValue)
      setRenderData(
        data && data?.find((item) => item?.role_label === tabValue)
      );
  }, [tabValue, data]);
  return (
    <Box sx={{ display: "flex", flexDirection: "row", width: "inherit" }}>
      <Box
        sx={{
          borderTopLeftRadius: "12px",
          borderBottomLeftRadius: "12px",
          // width: "7.5%",
        }}
      >
        {sidebarTable && Boolean(data?.length) && (
          <VerticalTab
            tab={
              lobName === "Motor"
                ? tabs.filter(
                    (role) => role.label !== "BS" && role.label !== "BSTL"
                  )
                : tabs
            }
            handleChange={handleChange}
          />
        )}
      </Box>

      {/* Stepper */}
      {data?.length && renderData ? (
        <Box
          sx={{
            padding: "1.5rem 0rem 1.5rem 3rem",
            height: "30.3rem",
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px",
            bgcolor: "#FBFBFF",
            width: "92.5%",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              overflowWrap: "break-word",
              whiteSpace: "normal",
              overflowY: "scroll",
              "&::-webkit-scrollbar": {
                width: "7px",
              },
              width: "100%",
              height: "27.2rem",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "12px",
                textTransform: "uppercase",
                color: "#E42125",
                paddingTop: "1.5rem",
              }}
            >
              {renderData?.employee_name}
            </Typography>
            <Stepper
              orientation="vertical"
              activeStep={-1}
              connector={<CustomConnector />}
            >
              {renderData?.description_details?.map((item, index) => (
                <Step key={index} expanded>
                  <StepLabel
                    StepIconComponent={CustomStepIcon}
                    sx={{
                      "& .MuiStepLabel-label": {
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        color: "black",
                        ml: "5px",
                      },
                    }}
                  >
                    {item.described_at?.replace(" ", " | ")}
                  </StepLabel>
                  <StepContent>
                    <Typography sx={{ fontSize: "1.1rem" }}>
                      {item.description}
                    </Typography>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Box>
      ) : (
        <>
          {
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
                fontSize: "1.2rem",
                fontWeight: 600,
                color: "#666666",
                textAlign: "center",
                padding: "2rem",
                height: "27.2rem",
              }}
            >
              No Data
            </Box>
          }
        </>
      )}
    </Box>
  );
};
export default CommentsBox;
